<template>
  <div class="pb-2">
    <ValidationObserver v-slot="{ handleSubmit }" ref="formDemandaCompatible">
      <b-form @submit.prevent="handleSubmit(confirmOferta)">
        <div>
          <PRow>
            <PCol lg="6">
              <div class="pl-2 pr-3">
                <OfertaDemandaDetalle :ofertaDemanda="demanda" />
              </div>
            </PCol>
            <PCol md="6" lg="6">
              <div class="pl-3 pr-3">
                <div>
                  <b-card-title class="data-form pl-3 pt-4">
                    {{ $t("label.transferir") }}
                  </b-card-title>
                  <div>
                    <PRow>
                      <PCol>
                        <PDataLine
                          class="mb-0"
                          :value="{
                            cliente: oferta.clientexdel.cliente.desCliente,
                            delegacion: oferta.clientexdel.delegacion.desDelegacion,
                            divisa: demanda.divisa.simbolo + ' ' + demanda.divisa.codDivisa,
                          }"
                          :fields="{
                            cliente: { title: $t('label.cliente') },
                            delegacion: { title: $t('label.delegacion') },
                            divisa: { title: $t('label.divisa') },
                          }"
                          :showSeparators="true"
                        />
                      </PCol>
                    </PRow>
                    <PRow class="mt-2">
                      <PCol>
                        <PDataLine
                          class="mb-0"
                          :value="{
                            saldoRestante: `${demanda.divisa.simbolo} ${filterNumber(
                              saldoRestante,
                              2
                            )}`,
                            totalOfertar: `${demanda.divisa.simbolo} ${filterNumber(
                              saldoOfertar,
                              2
                            )}`,
                          }"
                          :fields="{
                            saldoRestante: { title: $t('label.saldo.restante') },
                            totalOfertar: { title: $t('label.total.ofertar') },
                          }"
                          :widthContent="true"
                          :showSeparators="true"
                        />
                      </PCol>
                    </PRow>
                    <PRow>
                      <PCol>
                        <PTableSimple :fields="fields_PTableSimple" :items="detallesRelacionar">
                          <template #denominacion="{ item }">
                            {{ item.soCalidadDenominacion.denominacion.codDenominacion }}
                            {{ item.soCalidadDenominacion.desCalidad }}
                          </template>
                          <template #disponible="{ item }">
                            {{ demanda.divisa.simbolo }}
                            {{ filterNumber(item.soVDetalleOferta.cantidadDisponible, 2) }}
                          </template>
                          <template #ofertado="{ item, showExtend }">
                            <div
                              @click="showExtend"
                              class="denominacion-importe"
                              v-if="
                                demanda.checkParcial &&
                                item.cantidadOrigen > 0 &&
                                item.soVDetalleOferta.cantidadDisponible > 0
                              "
                            >
                              {{ demanda.divisa.simbolo }}
                              {{ filterNumber(item.soCalidadDenominacion.importe, 2) }}
                            </div>
                            <div v-else>
                              {{ demanda.divisa.simbolo }}
                              {{ filterNumber(item.cantidadOrigen, 2) }}
                            </div>
                          </template>
                          <template #extend="{ item, index }">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="`required|min_value:0|valid-denomination:${item.soCalidadDenominacion.denominacion.numValue}`"
                              :name="`cantidad-denominacion_${index}`"
                              v-if="
                                demanda.checkParcial &&
                                item.cantidadOrigen > 0 &&
                                item.soVDetalleOferta.cantidadDisponible > 0
                              "
                            >
                              <b-card class="input-card">
                                <b-card-body>
                                  <PRow>
                                    <PCol offset-lg="3" offset-md="3" lg="6" md="6">
                                      <b-form-group>
                                        <b-input
                                          type="number"
                                          min="0"
                                          :max="
                                            item.cantidadOrigen <=
                                            item.soVDetalleOferta.cantidadDisponible
                                              ? item.cantidadOrigen
                                              : item.soVDetalleOferta.cantidadDisponible
                                          "
                                          :step="item.soCalidadDenominacion.denominacion.numValue"
                                          v-model="item.soCalidadDenominacion.importe"
                                          :name="`cantidad-denominacion_${index}`"
                                          :id="`cantidad-denominacion_${index}`"
                                          :state="errors[0] ? false : null"
                                          :aria-describedby="`cantidad-denominacion-feedback_${index}`"
                                        />
                                      </b-form-group>
                                    </PCol>
                                  </PRow>
                                  <b-input
                                    type="range"
                                    min="0"
                                    :max="
                                      item.cantidadOrigen <=
                                      item.soVDetalleOferta.cantidadDisponible
                                        ? item.cantidadOrigen
                                        : item.soVDetalleOferta.cantidadDisponible
                                    "
                                    :step="item.soCalidadDenominacion.denominacion.numValue"
                                    v-model="item.soCalidadDenominacion.importe"
                                    class="mt-1"
                                  />
                                </b-card-body>
                              </b-card>

                              <b-form-invalid-feedback
                                :id="`cantidad-denominacion-feedback_${index}`"
                                class="d-block"
                              >
                                {{ errors[0] }}
                              </b-form-invalid-feedback>
                            </ValidationProvider>
                          </template>
                        </PTableSimple>
                      </PCol>
                    </PRow>
                    <PRow>
                      <PCol col="6" md="4">
                        <label class="label-form" for="coste">{{ $t("label.coste") }}</label>
                        <span class="data-form" id="coste">
                          {{ $t(`label.coste.${oferta.coste.codParametro}`) }}
                        </span>
                      </PCol>
                      <PCol col="6" md="4" v-if="demanda.clientexdel.cliente.pais.hasTasa">
                        <label class="label-form" for="tasa">{{ $t("label.tasa") }}</label>
                        <span
                          v-if="!demanda.clientexdel.cliente.pais.hasTasaEnteros"
                          class="data-form"
                          id="tasa"
                          >{{ filterNumber(demanda.numTasa, 5) }} %</span
                        >
                        <span
                          v-if="demanda.clientexdel.cliente.pais.hasTasaEnteros"
                          class="data-form"
                          id="tasa"
                        >
                          {{ Math.round(demanda.numTasa * 100000) }} x 10.000
                        </span>
                      </PCol>
                    </PRow>
                    <PRow v-if="isShowBankField">
                      <PCol md="6">
                        <label class="label-form" for="cuentaCorriente">{{
                          $t("label.cuenta_corriente")
                        }}</label>
                        <span class="data-form" id="cuentaCorriente">{{
                          oferta.cuentaCorriente
                        }}</span>
                      </PCol>
                      <PCol md="6">
                        <label class="label-form" for="agNumeroSucursal">{{
                          $t("label.ag_numero_sucursal")
                        }}</label>
                        <span class="data-form" id="agNumeroSucursal">{{
                          oferta.agNumeroSucursal
                        }}</span>
                      </PCol>
                    </PRow>
                    <PRow v-if="isShowBankField">
                      <PCol md="6">
                        <label class="label-form" for="cnpjPersona">{{
                          $t("label.cnpj_persona")
                        }}</label>
                        <span class="data-form" id="cnpjPersona">{{ oferta.cnpjPersona }}</span>
                      </PCol>
                      <PCol md="6">
                        <label class="label-form" for="ispbBanco">{{
                          $t("label.ispb_banco")
                        }}</label>
                        <span class="data-form" id="ispbBanco">{{ oferta.ispbBanco }}</span>
                      </PCol>
                    </PRow>
                    <PRow>
                      <PCol>
                        <label class="label-form" for="observaciones">{{
                          $t("label.observaciones")
                        }}</label>
                        <span class="data-form" id="observaciones">{{ oferta.observaciones }}</span>
                      </PCol>
                    </PRow>
                  </div>
                </div>
              </div>
            </PCol>
          </PRow>
          <PRow class="mb-3 mt-5">
            <PCol class="text-center">
              <b-button
                pill
                variant="outline-primary"
                class="p-button-secondary mr-4"
                @click="cancelar"
                >{{ $t("label.cancelar") }}</b-button
              >
              <b-button
                pill
                variant="primary"
                class="p-button-primary ml-4"
                :disabled="continuarCondition"
                type="submit"
                >{{ $t("label.transferir") }}</b-button
              >
            </PCol>
          </PRow>
        </div>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { IDetalleTransferencia, IOfertaDemanda, ITransferenciaRelacionar } from "@/entities";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import VueFilters from "@/vue-filters";
import TransferenciaDetalle from "@/pages/transferencias/common/TransferenciaDetalle.vue";
import OfertaDemandaDetalle from "@/pages/transferencias/common/OfertaDemandaDetalle.vue";
import { SweetAlertResult } from "sweetalert2";

@Component({
  name: "relacionar-con-demanda",
  mixins: [VueFilters],
  components: {
    OfertaDemandaDetalle,
    TransferenciaDetalle,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class RelacionarConDemanda extends Vue {
  @Prop({ required: true }) oferta!: IOfertaDemanda;
  @Prop({ required: true }) demanda!: IOfertaDemanda;
  isShowBankField = false;

  $refs!: {
    formDemandaCompatible: InstanceType<typeof ValidationObserver>;
  };

  mounted(): void {
    this.isShowBankField = this.oferta.clientexdel.cliente.pais.hasInfoBancaria || false;

    if (this.demanda.checkParcial) {
      this.oferta.detallesOferta!.forEach((value) => {
        this.$set(value.soCalidadDenominacion, "importe", 0);
      });
    }
  }

  get continuarCondition(): boolean {
    return !(!this.demanda.checkParcial || (this.saldoOfertar > 0 && this.demanda.checkParcial));
  }

  get fields_PTableSimple(): { key: string; label: string }[] {
    return [
      { key: "denominacion", label: this.$t("label.denominacion") },
      { key: "disponible", label: this.$t("label.disponible") },
      { key: "ofertado", label: this.$t("label.ofertado") },
    ];
  }

  get detallesRelacionar(): IDetalleTransferencia[] {
    let detallesRelacionar: IDetalleTransferencia[] = [];
    this.oferta.detallesOferta!.forEach((detalleOf) => {
      let detalleDemanda = this.demanda.detallesDemanda!.find(
        (detalleDe) => detalleDe.soCalidadDenominacion.id === detalleOf.soCalidadDenominacion.id
      );
      if (detalleDemanda) {
        let detalleRelacionar: IDetalleTransferencia = {
          id: 0,
          cantidadDemandada: 0,
          cantidadTransferida: 0,
          cantidadOrigen: detalleDemanda.cantidadDisponible,
          cantidadSolicitud: 0,
          soCalidadDenominacion: detalleOf.soCalidadDenominacion,
          soVDetalleOferta: detalleOf,
          soVDetalleDemanda: detalleDemanda,
        };
        detallesRelacionar.push(detalleRelacionar);
      }
    });
    return detallesRelacionar;
  }

  get saldoRestante(): number {
    return this.oferta.cantidadDisponible - this.saldoOfertar;
  }

  get saldoOfertar(): number {
    let sumaImportes = 0;
    if (this.demanda.checkParcial) {
      this.oferta.detallesOferta!.forEach((value) => {
        if (value.soCalidadDenominacion.importe) {
          sumaImportes = Number(sumaImportes) + Number(value.soCalidadDenominacion.importe);
        }
      });
      return sumaImportes;
    } else {
      return this.demanda.cantidadDisponible;
    }
  }

  cancelar(): void {
    this.$emit("cancel");
  }

  async confirmOferta(): Promise<void> {
    const res = await this.confirmTransferencia();
    if (res.isConfirmed) {
      await this.ofertar();
    }
  }

  async confirmTransferencia(): Promise<SweetAlertResult> {
    return this.$swal({
      title: this.$t("label.confirmar"),
      text: this.$t("label.transferencias.disclaimer"),
      icon: "question",
      showCancelButton: true,
      confirmButtonText: this.$t("label.yes"),
      cancelButtonText: this.$t("label.no"),
    });
  }

  async ofertar(): Promise<void> {
    let transferencia: ITransferenciaRelacionar = {
      idOferta: this.oferta.id,
      idDemanda: this.demanda.id,
      detalles: [],
    };
    if (this.demanda.checkParcial) {
      this.detallesRelacionar.forEach((value) => {
        if (value.soCalidadDenominacion.importe > 0) {
          transferencia.detalles.push({
            idCalidadDenominacion: value.soCalidadDenominacion.id,
            cantidadOfertada: value.soCalidadDenominacion.importe,
          });
        }
      });
    } else {
      this.detallesRelacionar.forEach((value) => {
        transferencia.detalles.push({
          idCalidadDenominacion: value.soCalidadDenominacion.id,
          cantidadOfertada: value.cantidadOrigen,
        });
      });
    }
    this.$emit("action", { action: "relacionarConDemanda", data: transferencia });
  }
}
</script>

<style lang="scss" scoped>
.label-form {
  font-size: 12px;
  line-height: 16px;
  font-weight: normal;
  color: var(--secundario-prosegur-oscuro-plus-10);
  margin-bottom: 0;
}

.denominacion-importe {
  color: var(--amarillo-prosegur);
  cursor: pointer;
}
.input-card {
  margin: 1rem 0;
  padding: 1rem;
  border-radius: 6px;
  border: solid 0.7px #f1f0f0;
  background-color: rgba(255, 209, 2, 0.04);
}
.textError {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}
.buttons_DemandarSobreOferta {
  display: flex;
  justify-content: center;
}
.textarea {
  height: 100px;
  width: 100%;
  border-radius: 6px;
  border: solid 1px #ced4da;
}
.data-form {
  font-size: 14px;
  font-weight: bold;
  line-height: 16px;
  color: var(--secundario-prosegur-claro);
  text-transform: initial;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  width: 99%;
  overflow: hidden;
}
</style>
